var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgGreenScribble = function SvgGreenScribble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 108,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.056 98.922c-8.043-21.577-13.248-43.565-17.933-66.082-.173-.835-1.632-15.162-3.612-16.422-1.95-1.24-7.845 42.351-8.277 45.325-.023.158-3.074 11.647-3.35 11.232-4.08-6.118-4.213-17.325-5.847-24.238-2.74-11.6-6.652-23.065-11.495-33.961-4.165-9.372-9.067 8.552-10.313 11.627-3.63 8.954-5.828 17.265-6.831 26.8-.543 5.152-.786 4.904-.986-.197-.432-11.017-3.234-22.168-6.503-32.647-2.24-7.183-5.712-15.929-10.838-4.992-5.544 11.827-8.93 24.702-12.153 37.31-1.55 6.07-2.327-4.15-2.627-5.451-2.398-10.39-4.911-21.027-10.642-30.151C13.937 15.94 9 8.241 9 9.061",
    stroke: "#27E123",
    strokeWidth: 17.394,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgGreenScribble;